<mat-toolbar color="accent">Edit Terminal</mat-toolbar>

<mat-dialog-content>
  <div class="flex flex-col gap-4 py-4">
    <div class="mb-4 flex max-w-4xl flex-col gap-4 sm:flex-row">
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>Terminal Display Name</mat-label>
        <input matInput [formControl]="nameControl" />
      </mat-form-field>

      <mat-form-field
        class="flex-1"
        floatLabel="always"
        subscriptSizing="dynamic"
      >
        <mat-label>Preferred Bridge</mat-label>
        <mat-select
          [placeholder]="
            data.terminalWithMerchants | map: getAutomaticBridgeLabel
          "
          [formControl]="preferredBridgeControl"
          [compareWith]="compareWithBridge"
        >
          <mat-option [value]="undefined">
            {{ data.terminalWithMerchants | map: getAutomaticBridgeLabel }}
          </mat-option>
          @for (
            bridgeOption of data.terminalWithMerchants.bridgeOptions;
            track bridgeOption.id
          ) {
            <mat-option [value]="bridgeOption.ref">
              {{ bridgeOption.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <table class="w-full" mat-table [dataSource]="pairRows()">
      <ng-container matColumnDef="merchant">
        <th *matHeaderCellDef mat-header-cell>Merchant</th>
        <td *matCellDef="let row" mat-cell>
          <div class="flex flex-col">
            <span class="font-bold">{{ row.merchantDisplayName }}</span>
            <span class="text-xs text-gray-500">{{ row.merchantId }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="enabled">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell class="w-16">
          <mat-slide-toggle
            [checked]="row.enabled"
            (change)="merchantEnabledChanged(row.merchantId, $event.checked)"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="bridgeConnections">
        <th *matHeaderCellDef mat-header-cell>Bridge Connections</th>
        <td class="py-2" *matCellDef="let row" mat-cell>
          <div class="flex flex-col gap-2">
            @for (bridgeRow of row.bridges; track bridgeRow.bridgeId) {
              <div class="flex items-center gap-2 rounded bg-gray-50 p-2">
                <span
                  class="h-2.5 w-2.5 shrink-0 rounded-full"
                  [ngClass]="{
                    'bg-green-500': bridgeRow.isBridgeActive,
                    'bg-gray-400': !bridgeRow.isBridgeActive
                  }"
                  [matTooltip]="bridgeRow.bridgeStatusTooltip"
                ></span>
                <span class="grow font-bold">{{ bridgeRow.bridgeName }}</span>
                @if (bridgeRow.edge.stale) {
                  <span
                    class="rounded bg-red-100 px-2 py-0.5 text-xs font-bold text-red-800"
                  >
                    Stale
                  </span>
                }
                <span
                  class="cursor-help underline decoration-dotted"
                  matTooltipClass="tooltip-multiline"
                  [matTooltip]="bridgeRow.connectionTooltip"
                >
                  {{ bridgeRow.edge.isLocal ? 'Serial' : 'Network' }}
                </span>
                <span>·</span>
                <span>
                  Last synced
                  {{
                    bridgeRow.edge.lastSeen | moment | amDateFormat: dateFormat
                  }}
                </span>
                <button
                  mat-icon-button
                  color="warn"
                  class="icon-xs"
                  matTooltip="Remove connection"
                  (click)="removeBridge(bridgeRow.bridgeId)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </td>
      </ng-container>

      <tr
        *matHeaderRowDef="['enabled', 'merchant', 'bridgeConnections']"
        mat-header-row
      ></tr>
      <tr
        *matRowDef="
          let row;
          columns: ['enabled', 'merchant', 'bridgeConnections']
        "
        mat-row
      ></tr>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="nameControl.invalid"
      (click)="save()"
    >
      Save
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
